export default {
    'Mega Menu': 'Mega Menu',
    Search: 'Search',
    Menu: 'Menu',
    Dashboard: 'Dashboard',
    Calendar: 'Calendar',
    Chat: 'Chat',
    Ecommerce: 'Ecommerce',
    Products: 'Products',
    'Product Detail': 'Product Detail',
    Orders: 'Orders',
    Customers: 'Customers',
    Cart: 'Cart',
    Checkout: 'Checkout',
    Shops: 'Shops',
    'Add Product': 'Add Product',
    Email: 'Email',
    Inbox: 'Inbox',
    'Read Email': 'Read Email',
    'Kanban Board': 'Kanban Board',
    Layouts: 'Layouts',
    Horizontal: 'Horizontal',
    'Dark Sidebar': 'Dark Sidebar',
    'Default Sidebar': 'Default Sidebar',
    'Compact Sidebar': 'Compact Sidebar',
    'Icon Sidebar': 'Icon Sidebar',
    'Boxed Layout': 'Boxed Layout',
    'Fluid Layout': 'Fluid Layout',
    Preloader: 'Preloader',
    'Without Preloader': 'Without Preloader',
    Pages: 'Pages',
    Authentication: 'Authentication',
    Login: 'Login',
    Register: 'Register',
    'Recover Password': 'Recover Password',
    'Lock Screen': 'Lock Screen',
    Utility: 'Utility',
    'Starter Page': 'Starter Page',
    Maintenance: 'Maintenance',
    'Coming Soon': 'Coming Soon',
    Timeline: 'Timeline',
    FAQs: 'FAQs',
    Pricing: 'Pricing',
    'Error 404': 'Error 404',
    'Error 500': 'Error 500',
    Components: 'Components',
    'UI Elements': 'UI Elements',
    Alerts: 'Alerts',
    Buttons: 'Buttons',
    Cards: 'Cards',
    Carousel: 'Carousel',
    Dropdowns: 'Dropdowns',
    Grid: 'Grid',
    Images: 'Images',
    Lightbox: 'Lightbox',
    Modals: 'Modals',
    'Range Slider': 'Range Slider',
    'Round Slider': 'Round Slider',
    'Session Timeout': 'Session Timeout',
    'Progress Bars': 'Progress Bars',
    'Sweet Alerts': 'Sweet Alerts',
    'Tabs & Accordions': 'Tabs & Accordions',
    Typography: 'Typography',
    Video: 'Video',
    General: 'General',
    Rating: 'Rating',
    Notifications: 'Notifications',
    Forms: 'Forms',
    Elements: 'Elements',
    Validation: 'Validation',
    'Advanced Plugins': 'Advanced Plugins',
    Editors: 'Form Editors',
    'File Upload': 'Form File Upload',
    'X-editable': 'Form Xeditable',
    Wizard: 'Wizard',
    Mask: 'Mask',
    Tables: 'Tables',
    'Basic Tables': 'Basic Tables',
    'Data Tables': 'Data Tables',
    'Responsive Table': 'Responsive Table',
    'Editable Table': 'Editable Table',
    Charts: 'Charts',
    Apexcharts: 'Apexcharts',
    Chartist: 'Chartist',
    Chartj: 'Chartjs',
    'Jquery Knob': 'Jquery Knob',
    Sparkline: 'Sparkline',
    Icons: 'Icons',
    'Remix Icons': 'Remix Icons',
    'Material Design': 'Material Design',
    Dripicons: 'Dripicons',
    'Font awesome 5': 'Font awesome 5',
    Maps: 'Maps',
    'Google Maps': 'Google Maps',
    'Vector Maps': 'Vector Maps',
    'Multi Level': 'Multi Level',
    'Level 1.1': 'Level 1.1',
    'Level 1.2': 'Level 1.2',
    'Level 2.1': 'Level 2.1',
    'Level 2.2': 'Level 2.2',
    Profile: 'Profile',
    'My Wallet': 'My Wallet',
    Settings: 'Settings',
    'View more': 'View more',
    'View all': 'View all',
    Logout: 'Logout',
    'Your order is placed': 'Your order is placed',
    'If several languages coalesce the grammar': 'If several languages coalesce the grammar',
    'Your item is shipped': 'Your item is shipped',
    '3 min ago': '3 min ago',
    'James Lemire': 'James Lemire',
    'It will seem like simplified English.': 'It will seem like simplified English.',
    '1 hours ago': '1 hours ago',
    'Salena Layfield': 'Salena Layfield',
    'As a skeptical Cambridge friend of mine occidental.': 'As a skeptical Cambridge friend of mine occidental.',
    'View More..': 'View More..',
    'UI Components': 'UI Components',
    Applications: 'Applications',
    'Extra Pages': 'Extra Pages',
    Github: 'Github',
    Bitbucket: 'Bitbucket',
    Dribble: 'Dribble',
    Dropbox: 'Dropbox',
    'Mail Chimp': 'Mail Chimp',
    Slack: 'Slack',
    'Add new portfolio': 'Add new portfolio',
    'Add tariff': 'Add tariff',
    'Add options': 'Add options',
    Overview: 'Overview',
    Administration: 'Administration',
    'Option group': 'Option group',
    'Option value': 'Option value',
    Name: 'Name',
    'Valid for': 'Valid for',
    Notes: 'Notes',
    'Package name': 'Package name',
    Tariff: 'Tariff',
    Type: 'Type',
    Level: 'Level',
    Price: 'Price',
    Subsidy: 'Subsidy',
    Cancel: 'Cancel',
    Previous: 'Previous',
    Next: 'Next',
    Active: 'Active',
    Yes: 'Yes',
    No: 'No',
    Options: 'Options',
    'Group to application role mapping': 'Group to application role mapping',
    'Select role': 'Select role',
    'Add group': 'Add group',
    'Role mapping': 'Role mapping',
    Portfolio: 'Portfolio',
    User: 'User',
    State: 'State',
    Status: 'Status',
    Stage: 'Stage',
    All: 'All',
    Offers: 'Offers',
    'Offer status': 'Offer status',
    'Portfolio share': 'Portfolio share',
    Range: 'Range',
    Date: 'Date',
    Day: 'Day',
    Week: 'Week',
    Month: 'Month',
    '3 months': '3 months',
    '6 months': '6 months',
    Year: 'Year',
    Won: 'Won',
    Lost: 'Lost',
    String: 'Text',
    Number: 'Number',
    Boolean: 'True/False',
    'VAT ID': 'VAT ID',
    RND: 'Round number',
    COM: 'Combine 2 vectors',
    EXP: 'Expand on vector value',
    RED: 'Reduce tensor input to vector',
    MIN: 'Minimum value',
    MAX: 'Maximum value',
    ROW: 'Table row operation',
    VEC: 'Vector operation',
    XTR: 'Extract values from vector',
    SUM: 'Calculate sum of row values',
    AVG: 'Calculate average of row values',
    LOW: 'Calculate lowest value in rows',
    TOP: 'Calculate greatest value in rows',
    CNT: 'Calculate count of row values',
    O: 'No operation',
    FF: 'Form field',
    PRM: 'Parameter',
    BOOL: 'Boolean',
    CONST: 'Constant',
    DIV: 'Divide',
    EQUAL: 'Equal',
    EXPRESSION: 'Expression',
    GRTTHN: 'Greater than',
    LSTHN: 'Less than',
    LSEQ: 'Less than or equal',
    GRTEQ: 'Greater than or equal',
    COUNT: 'Count',
    TXT: 'Text',
    TIME: 'Times',
    VAR: 'Variable',
    STACK: 'Stack',
    RNG: 'Range',
    NOTEQ: 'Not equal',
    NUM: 'Number',
    SUB: 'Subtraction',
    ADD: 'Addition',
    MULT: 'Multiply',
    WaitingForApproval: 'Waiting for approval',
    ThreeMonths: 'Three months',
    SixMonths: 'Six months'
};
